

import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { showModal } from "../../features/modal/modalSlice"
import Button from "../shared/Button"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { useScrollLock } from "../../hooks/useScrollLock"
import {MdSearch} from "react-icons/md"
import { filterSearch } from "../../features/search/searchSlice"
import textColoredMaker from "../../helper/textColoredMaker"


import {AiOutlineStar} from "react-icons/ai"
import {FiMenu} from "react-icons/fi"
import {TbLetterL} from "react-icons/tb"
import { useRef } from "react"


const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 950px;
        height: auto;
        min-height: 600px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .searchbar-container{
            padding: 20px;
            border-bottom: 1px solid ${({ theme }) => theme.mainBorderColor};
            width: 100%;
            
            .searchbar-wrapper{
                background-color: ${({ theme }) => theme.secondaryBgColor};
                height: 45px;
                width: 100%;
                border-radius: 10px;
                cursor: text;
                display: flex;
                align-items: center;
                
                .search-icon{
                    font-size: 1.8rem;
                    width: 40px;
                    fill: ${({ theme }) => theme.mainTextColor};
                }
                
                input{
                    width: 100%;
                    height: 100%;
                    background-color: transparent;
                    font-weight: var(--font-weight-lg);
                    font-size: var(--font-size-sm);
                    
                    &::placeholder{
                        color: ${({ theme }) => theme.secondaryTextColor};
                    }
                }
            }
        }

        .content{
            width: 100%;
            padding: 40px;
            min-height: 500px;
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 500px;
            overflow: auto;

            &::-webkit-scrollbar {
                width: 8px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #9e9b9b;
                border-radius: 10px;
            }
            &::-webkit-scrollbar-track {
                background-color: transparent;
            }

            .result-list{
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 20px;

                .menu-container{
                    width: 100%;
                    margin-bottom: 20px;


                    .menu-name{
                        font-size: var(--font-size-md);
                        font-weight: var(--font-weight-lg);
                        margin-bottom: 5px;
                    }

                    .sub-menu-list{
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                    }
                }

            }


        }
    }
`

const LinkContainer = styled(Link)`
    display: flex;
    flex-direction: column;
    background-color: ${({ theme, isActive }) => isActive ? "var(--color-main)" : theme.secondaryBgColor};
    color: ${({ theme, isActive }) => isActive ? "#fff" : theme.mainTextColor};
    border-radius: 8px;
    padding: 10px;
    cursor: pointer;
    border: 2px solid transparent;
    
    &:hover{
        /* background-color: var(--color-main);
        color: #000; */
        border: 2px solid ${({theme}) => theme.contrastBorderColor};

    }

    .sub-menu-item{
        display: flex;
        align-items: center;
        gap: 5px;

        .menu-icon-contanier{
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 5px;
            border-radius: 4px;
            background-color: ${({ theme, isActive }) => isActive ? "#fff" : theme.secondaryBgColor};

            .menu-icon{
                font-size: 1.4rem;
                color: ${({ theme, isActive }) => isActive ? "var(--color-main)" : theme.mainTextColor};
            }
        }

        .sub-menu-content{
            display: flex;
            flex-direction: column;
            gap: 5px;

            .sub-menu-name{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                padding-right: 5px;
            }

        }

        .sub-menu-keywords{
            width: 100%;
            display: flex;
            justify-content: space-between;
        }

    }

    .sub-menu-keywords{

    }

    .bold{
                /* background-color: var(--color-main); */
                color: var(--color-main);
                color: ${({ theme, isActive }) => isActive ? "#fff" : "var(--color-main)"};
                text-decoration: underline;
                font-weight: var(--font-weight-xl);
            }
`


const SearchModal = () => {
    const { modalLocation } = useSelector((state) => state.modal);
    const { searchResults } = useSelector((state) => state.search);
  
    const [orderedList, setOrderedList] = useState([]);
    const [activeSearchItem, setActiveSearchItem] = useState(null);
    const itemRefs = useRef([]);
  
    const dispatch = useDispatch();
    const location = useLocation();
  
    const { lockScroll, unlockScroll } = useScrollLock();
    const [isSearching, setIsSearching] = useState(false);
    const [currentSearch, setCurrentSearch] = useState("");

    const navigate = useNavigate()
  
    useEffect(() => {
      lockScroll();
      return () => {
        unlockScroll();
      };
    }, [lockScroll, unlockScroll]);
  
    useEffect(() => {
      if (location.pathname !== modalLocation) {
        dispatch(showModal(null));
      }
    }, [dispatch, location.pathname, modalLocation]);
  
    useEffect(() => {
      if (currentSearch.length >= 3) {
        dispatch(filterSearch(currentSearch));
      }
    }, [currentSearch, dispatch]);
  
    useEffect(() => {
      if (searchResults.length > 0) {
        const list = searchResults
          .map((item) => item.menuList)
          .flat()
          .map((item, i) => ({ ...item, index: i }));
  
        setOrderedList(list);
        setActiveSearchItem(list[0]);
      }
    }, [searchResults]);
  
    useEffect(() => {
      const handleKeyDown = (event) => {
        if (event.key === 'ArrowDown' && orderedList.length > 0) {
          const nextItem =
            orderedList.find((item) => item.index === activeSearchItem.index + 1) || orderedList[0];
          setActiveSearchItem(nextItem);
        } else if (event.key === 'ArrowUp' && orderedList.length > 0) {
          const prevItem =
            orderedList.find((item) => item.index === activeSearchItem.index - 1) ||
            orderedList[orderedList.length - 1];
          setActiveSearchItem(prevItem);
        } else if (event.key === 'Enter') {
            navigate(activeSearchItem.path)
        }
      };
  
      window.addEventListener('keydown', handleKeyDown);
  
      return () => {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }, [activeSearchItem, orderedList]);

  
    useEffect(() => {
      if (activeSearchItem && itemRefs.current[activeSearchItem.index]) {
        const element = itemRefs.current[activeSearchItem.index];
        const { top, bottom } = element.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  
        if (top < 0 || bottom > viewportHeight) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }, [activeSearchItem]);
  
    return (
      <Container onClick={() => dispatch(showModal(null))} isSearching={isSearching}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
          <div className="searchbar-container">
            <div className="searchbar-wrapper" onClick={() => setIsSearching(true)}>
              <MdSearch className="search-icon" />
              <input
                type="text"
                value={currentSearch}
                onChange={(e) => setCurrentSearch(e.target.value)}
                placeholder="İşlem Ara"
              />
            </div>
          </div>
          <div className="content">
            {currentSearch.length >= 3 && (
              <div className="result-list">
                {searchResults.map((menuItem, i) => (
                  <div className="menu-container" key={i}>
                    <h3 className="menu-name">{menuItem.mainMenu}</h3>
                    <div className="sub-menu-list">
                      {menuItem.menuList.map((item, i) => (
                        <LinkContainer
                          to={item.path}
                          isActive={item?.id === activeSearchItem?.id}
                          key={i}
                          ref={(el) => (itemRefs.current[item.index] = el)}
                        >
                          <div className="sub-menu-item" id={item.id}>
                            <div className="menu-icon-contanier">
                              <FiMenu className="menu-icon" />
                            </div>
                            <div className="sub-menu-content">
                              <h4 className="sub-menu-name">{item.altMenu}</h4>
                              <div
                                className="preview"
                                dangerouslySetInnerHTML={{
                                  __html: textColoredMaker(currentSearch, item.desc)
                                }}
                              />
                            </div>
                          </div>
                          <div className="sub-menu-keywords"></div>
                        </LinkContainer>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </Container>
    );
  };
  
  export default SearchModal;


  
  